<template>
  <div class="">
    <longterm-stock v-if="tab === 'long-term-stock'"></longterm-stock>
    <product-available v-if="tab === 'product-available'"></product-available>
    <settings v-if="tab === 'settings'"></settings>
  </div>
</template>
<script>
import LongtermStock from './LongtermStock'
import ProductAvailable from './ProductAvailable'
import Settings from './Settings'

export default {
  components: {
    LongtermStock,
    ProductAvailable,
    Settings
  },
  props: {
    tab: {
      type: String,
      default: 'long-term-stock'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/salemonAgent/TabContent.vue